export default "__VITE_ASSET__Pz3Z_zL0__"